<div class="login-outer">
  <div class="login-card card-section">
    <div class="login-logo">
      <img src="favicon.ico" alt="Bruchpilot" class="login-favicon">
      <span>Bruchpilot</span>
    </div>
    <h2 class="login-title">Sign in</h2>
    <form (ngSubmit)="onLogin()">
      <div class="mb-3">
        <label for="username" class="form-label">Username</label>
        <input type="text" class="form-control" id="username" name="username" [(ngModel)]="username" required>
      </div>
      <div class="mb-3">
        <label for="password" class="form-label">Password</label>
        <input type="password" class="form-control" id="password" name="password" [(ngModel)]="password" required>
      </div>
      <button type="submit" class="btn btn-primary w-100">Login</button>
    </form>
    @if (login_status) {
      <p class="login-error">{{ login_status }}</p>
    }
  </div>
</div>
